import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { openUrl } from '@whelk/utils';
import Button from '@whelk/components/src/Base/Button';
import { RootState } from '@whelk/store';
import { isOverseas } from '@whelk/const/src/env';

// 渲染封禁内容
const BannedContent = ({
  setIsAppealForm,
  onClose,
  onAppeal,
}: {
  setIsAppealForm: (isAppeal: boolean) => void;
  onClose: () => void;
  onAppeal: (params?: { email: string; successCb: () => void }) => void;
}) => {
  const { t } = useTranslation();
  // 获取封禁信息 包含是否显示弹窗，以及弹窗的封禁截止文案
  const bannedAppealModal = useSelector((state: RootState) => state?.user?.bannedAppealModal);
  // 获取教程链接信息
  const tutorialLinkInfo = useSelector((state: RootState) => state.config.tutorialLinkInfo);

  // 检查规则
  const checkRules = () => {
    if (!tutorialLinkInfo) return;
    openUrl(tutorialLinkInfo.url);
  };
  // 打开申诉表单
  const openAppealForm = () => {
    setIsAppealForm(true);
  };
  // 上报申诉
  const onAppealConfirm = async () => {
    if (isOverseas) {
      // 英文版打开申诉表单，填写邮箱信息
      openAppealForm();
    } else {
      // 中文版直接上报申诉
      onAppeal();
    }
  };
  return (
    <div className='max-w-[460px] text-[15px] font-normal leading-[24px] text-[#AFB2BB]'>
      <div>
        {/* 内容 */}
        {bannedAppealModal.message}
        {/* 规则 */}
        <span className='cursor-pointer text-[#1887FB]' onClick={checkRules}>
          &nbsp;{t('user_ban_appeal_rules')}
        </span>
      </div>
      <div className='mt-8 flex w-full justify-end gap-4 text-[14px] leading-[20px]'>
        <Button variant='blueText' onClick={onAppealConfirm}>
          {t('button_appeal_confirm')}
        </Button>
        <Button variant='blue' onClick={onClose}>
          {t('button_announcement_confirm')}
        </Button>
      </div>
    </div>
  );
};

export default BannedContent;
